import * as React from "react";
const appointmentContextDefaultValues = {
  config: { bookAppointmentUrl: "" },
  store: void 0,
  appointment: void 0,
  setStore: () => null,
  setAppointment: () => null
};
const CancelAppointmentContext = React.createContext(
  appointmentContextDefaultValues
);
const useCancelAppointmentContext = () => {
  const context = React.useContext(CancelAppointmentContext);
  if (context === appointmentContextDefaultValues) {
    throw new Error(
      "No CancelAppointmentContext available. You might still need to wrap the application with the CancelAppointmentProvider component."
    );
  }
  return context;
};
CancelAppointmentContext.displayName = "CancelAppointment";
CancelAppointmentContext.Consumer;
export {
  CancelAppointmentContext,
  appointmentContextDefaultValues,
  useCancelAppointmentContext
};
//# sourceMappingURL=context.js.map
